import React from 'react';
import { useTranslation } from 'react-i18next';

const TG_URL   = process.env.REACT_APP_TG_URL   || 'https://t.me/shalabin_mv';
const WA_URL   = process.env.REACT_APP_WA_URL   || 'https://wa.me/79203015560';
const MAX_URL  = process.env.REACT_APP_MAX_URL  || 'https://max.ru/u/f9LHodD0cOIyGGB54wqiMUiYqPDwOWy3UdtGHojDGsuPptcCRTFMhDXP7Ro';
const MAIL_URL = process.env.REACT_APP_MAIL_URL || 'mailto:sm@deal3dp.com';

const TelegramIcon = () => (
    <svg width="40" height="40" viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">
        <path d="M18.59 50.5l51.26-21.78c3.01-1.29 6 .39 5.56 3.63l-6.35 39.93c-.43 3.17-3.54 5.69-7.87 2.94l-16.29-11.04c-2.75-1.46-2.84-3.62-1.56-5.08l17.45-17.28c.92-.97-.36-1.78-1.19-1.22l-26.17 16.7c-1.08.67-2.41.81-3.61.39l-11.14-3.62c-2.15-.96-1.43-2.98-.07-3.56z"/>
    </svg>
);

const WhatsAppIcon = () => (
    <svg width="30" height="30" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="5" aria-hidden="true">
        <path d="M81.02 50.14c0 17.16-13.91 31.07-31.07 31.07-5.61 0-10.87-1.49-15.42-4.09-4.19.85-14.16 3-14.16 3 0 0 2.7-10.3 3.45-13.16-3.13-4.85-4.94-10.62-4.94-16.82 0-17.16 13.91-31.07 31.07-31.07s31.07 13.91 31.07 31.07z" strokeMiterlimit="10"/>
        <path d="M43.63 40.57l-1.87-4.69c-3.6-6.79-11.83 2.85-7.99 10.3 4.69 9.44 11.81 16.37 22.18 19.97 5.29 2.69 15.38-5.34 9.23-8.41l-4.28-2.14c-1.23-.61-2.72-.33-3.63.7-5.01 5.92-19.65-5.84-15.14-11.36l1.08-1.41c.65-.85.81-1.98.41-2.97z" fill="currentColor" strokeMiterlimit="10"/>
    </svg>
);

const MaxIcon = () => (
    <svg width="18" height="18" viewBox="0 0 100 100" fill="currentColor" aria-hidden="true">
        <path d="M50.7571 0.2617C78.2929 0.2617 99.8857 22.5974 99.8857 50.1474C99.8857 77.6974 77.6071 99.4903 51.0214 99.4903C41.5857 99.4903 37.0143 98.1617 29.65 92.9474C29.1429 92.5903 28.45 92.6831 28.0214 93.1403C22.3571 99.1831 7.85 103.426 7.18571 95.176C7.18571 80.7903 0 71.4474 0 49.876C0 21.5546 23.2214 0.2617 50.7571 0.2617ZM51.5286 24.8117C38.4643 24.126 28.2643 33.1974 26.0143 47.3831C24.15 59.1332 27.45 73.4546 30.2786 74.176C31.4786 74.4832 34.3571 72.276 36.4571 70.2974C36.85 69.926 37.45 69.8617 37.9071 70.1474C41.1786 72.1474 44.8786 73.6474 48.9571 73.8617C62.3714 74.5617 74.2571 64.0617 74.9643 50.6474C75.6643 37.2331 64.9429 25.5046 51.5286 24.8046V24.8117Z"/>
    </svg>
);

const MailIcon = () => (
    <svg width="30" height="30" viewBox="0 0 100 100" fill="none" stroke="currentColor" strokeWidth="5" strokeMiterlimit="10" aria-hidden="true">
        <rect x="18.93" y="27.5" width="62.14" height="45" rx="11.18"/>
        <path d="M22.21 30.78l22.45 15.36c3.19 2.31 7.49 2.31 10.68 0l22.43-15.33"/>
        <path d="M54.94 45.04l22.85 24.18M22.22 69.21l22.45-23.76"/>
    </svg>
);

const SECONDARY = [
    { key: 'whatsapp', url: WA_URL,   icon: <WhatsAppIcon />, external: true  },
    { key: 'max',      url: MAX_URL,  icon: <MaxIcon />,      external: true  },
    { key: 'mail',     url: MAIL_URL, icon: <MailIcon />,     external: false },
];

const CTASection = () => {
    const { t } = useTranslation();

    return (
        <section
            id="contact"
            className="py-24 bg-gray-900 border-t border-gray-800 relative overflow-hidden"
        >
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r
                          from-transparent via-emerald-800/60 to-transparent" />
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
                          w-[600px] h-[300px] bg-emerald-600/5 rounded-full blur-3xl" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 text-center flex flex-col gap-8">

                <div className="flex flex-col gap-5">
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                        {t('cta.title')}
                    </h2>
                    <p className="text-gray-400 text-lg">
                        {t('cta.subtitle')}
                    </p>
                </div>

                <div className="flex flex-col items-center gap-5">

                    {/* Основная кнопка */}

                    <a
                    href={TG_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2.5 px-8 py-4 bg-emerald-600
                    hover:bg-emerald-500 text-white font-bold text-base rounded-xl
                    transition-all duration-200 shadow-xl shadow-emerald-950/50
                    hover:-translate-y-0.5 hover:shadow-emerald-900/60"
                    >
                    <TelegramIcon />
                    {t('cta.button')}
                </a>

                {/* Альтернативные каналы */}
                <div className="flex items-center gap-2">
                    <span className="text-gray-600 text-sm mr-1">{t('cta.orVia')}</span>
                    {SECONDARY.map(({ key, url, icon, external }) => (
                    <a
                        key={key}
                        href={url}
                        title={t(`cta.channels.${key}`)}
                        aria-label={t(`cta.channels.${key}`)}
                    {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                        className="w-10 h-10 flex items-center justify-center rounded-lg
                        bg-white/5 hover:bg-white/10 text-gray-400 hover:text-white
                        border border-white/10 hover:border-white/20
                        transition-all duration-200"
                        >
                    {icon}
                        </a>
                        ))}
                </div>

                <p className="text-gray-600 text-sm max-w-md">{t('cta.note')}</p>
                <p className="text-gray-700 text-xs">{t('cta.price')}</p>
            </div>

        </div>
</section>
);
};

export default CTASection;
